module.exports = __webpack_public_path__ + "img/bujin_tiles.1dd1f182.jpg";